import "./index.css";
import React from "react";
import useButton from "./hooks/useButton";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import { observer } from "mobx-react-lite";
import PageNoSelect from "./PageNoSelect";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import PageNoInput from "./PageNoInput";
import ShopDTO from "@/dto/shop/ShopDTO";
import { useModalStore } from "@/hooks/Modal/hooks";

interface PaginationProps {
    shop: ShopDTO;

    tab: OrderTab;
}

const Pagination: React.FC<PaginationProps> = ({ shop, tab }) => {
    const orderManagementStore = useOrderManagementStore();
    const modalStore = useModalStore();
    const { pageNo, pageSize, totalCount = 0 } = orderManagementStore.table.pagination;

    const totalPages = Math.ceil(totalCount / pageSize);
    const startIndex = (pageNo - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, totalCount);
    const shopId = shop?.id;
    const { preButton, nextButton } = useButton(shopId, tab, totalPages);

    function buildRangeText() {
        if (!totalCount) return null;

        return `当前显示${startIndex + 1}-${endIndex}条订单，共${totalCount}
                            条(合并后)`;
    }

    return (
        <div className="pagination-bar">
            <div className="left">
                {preButton}
                <PageNoInput
                    pageNo={pageNo}
                    pageSize={pageSize}
                    totalCount={totalCount}
                    onPageNoChange={(pageNo) => {
                        orderManagementStore.table.changePageNo(pageNo);

                        orderManagementStore.fetchOrders(shopId, tab);
                    }}
                />
                {nextButton}
                <span className="form-control-static ml10">/ 共{totalPages}页</span>
                <span className="form-control-static ml20">每页显示：</span>
                <PageNoSelect shop={shop} tab={tab} />
            </div>
            <div className="right">
                <span className="form-st" style={{ marginTop: 2 }}>
                    {buildRangeText()}
                </span>
            </div>
        </div>
    );
};

export default observer(Pagination);
